webpackJsonp([31],{

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppPopupForm_vue__ = __webpack_require__(2512);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27077006_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppPopupForm_vue__ = __webpack_require__(3163);
function injectStyle (ssrContext) {
  __webpack_require__(3161)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27077006"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppPopupForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27077006_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppPopupForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return searchRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {
  id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入正确的APP浮窗配置ID', 'integer', 'blur', false), { min: 1 })]
};

var formRules = {
  title: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入标题', 'string', 'blur', true))],
  img_url: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请上传封面图片', 'string', 'blur', true))],
  target_type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择小浮窗事件', 'number', 'blur', true))],
  target_url: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入落地页路径', 'string', 'blur', true))],
  launch_time_range: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择上下线时间', 'array', 'blur', true))],
  user_currentstatus: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择展示对象', 'array', 'blur', true))]
};

/***/ }),

/***/ 2512:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_popup_rules_js__ = __webpack_require__(2121);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: 0,
      isDetailMode: false,
      formRules: __WEBPACK_IMPORTED_MODULE_3__app_popup_rules_js__["a" /* formRules */],
      form: {
        title: '',
        img_url: '',
        target_type: '',
        target_url: '',
        launch_time_range: [],
        user_currentstatus: []
      },
      targetTypes: [{ value: 1, label: '打开网页' }, { value: 2, label: '打开智能客服' }],
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; // 禁止选择今天之前的时间
        }
      },
      imgFileList: [],
      disableTargetUrl: false,
      disableUserCurrentStatus: false
    };
  },

  computed: Vuex.mapState({
    userOptions: function userOptions(state) {
      return state.users.options;
    }
  }),
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.onReload();
    next();
  },
  created: function created() {},
  mounted: function mounted() {
    this.isDetailMode = this.$route.path.includes('detail');
  },

  methods: {
    onLoad: function onLoad() {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id);
      }
    },
    onReload: function onReload() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.onLoad();
    },
    setForm: function setForm(id) {
      var _this = this;

      request.page('getAppPopupDetail', { id: id }).then(function (_ref) {
        var data = _ref.data;

        data.launch_time_range = [data.launch_time, data.end_time];
        data.target_type = Number(data.target_type);
        // 选择智能客服，禁止选择落地页路径和展示对象
        if (data.target_type === 2) {
          _this.disableTargetUrl = true;
          _this.disableUserCurrentStatus = true;
        }
        filter.setLoop(_this.form, data);
        _this.imgFileList = [{
          url: data.img_url
        }];
      });
    },
    getForm: function getForm() {
      return filter.copyJson(this.form);
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      if (this.isDetailMode) return; // 如果是详情模式，阻止提交
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this2.id ? _this2.update(_this2.id) : _this2.create();
        } else {
          _this2.$message.error('提交内容填写不正确！');
        }
      });
    },
    create: function create() {
      var _this3 = this;

      request.common('createAppPopupData', this.getForm()).then(function (res) {
        _this3.$confirm(_this3.$route.meta.title + '成功, 是否继续添加？', '提示', { type: 'success' }).then(function () {
          _this3.$refs.form.resetFields();
        }, function () {
          _this3.$router.push({ path: '/app-popup/table/' });
        });
      });
    },
    update: function update(id) {
      var _this4 = this;

      request.common('updateAppPopupData', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ id: id }, this.getForm())).then(function (res) {
        _this4.$confirm(_this4.$route.meta.title + '成功, 是否前往列表页面？', '提示', { type: 'success' }).then(function () {
          _this4.$router.push({ path: '/app-popup/table/' });
        });
      });
    },
    handleRemove: function handleRemove(valName) {
      this.form.img = '';
    },
    onChangeTargetType: function onChangeTargetType(newVal) {
      if (newVal === 2) {
        this.form.target_url = 'customer_service';
        this.disableTargetUrl = true;
        this.form.user_currentstatus = [0, 4];
        this.disableUserCurrentStatus = true;
      } else {
        this.form.target_url = '';
        this.disableTargetUrl = false;
        this.form.user_currentstatus = [];
        this.disableUserCurrentStatus = false;
      }
    },
    onChangeFile: function onChangeFile(file, fileList) {
      var _this5 = this;

      var isExcel = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
      var isLt2M = file.raw.size / 1024 / 1024 < 2;

      // 图片尺寸验证
      var checkImageDimensions = function checkImageDimensions(file) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
          var img = new Image();
          img.src = URL.createObjectURL(file);
          img.onload = function () {
            var width = img.width;
            var height = img.height;
            var isValid = width <= 250 && height <= 250;
            resolve(isValid);
          };
        });
      };

      if (!isExcel) {
        this.$message.error('请上传jpg/jpeg/png图片!');
        this.$refs.upload.clearFiles();
        return false;
      }
      if (!isLt2M) {
        this.$message.error('大小不能超过2MB!');
        this.$refs.upload.clearFiles();
        return false;
      }

      // 新增尺寸验证
      checkImageDimensions(file.raw).then(function (isValid) {
        if (!isValid) {
          _this5.$message.error('图片尺寸不能超过250x250像素!');
          _this5.$refs.upload.clearFiles();
          return false;
        }
        _this5.onUploadFile(file.raw);
      });
    },
    onUploadFile: function onUploadFile(file) {
      var _this6 = this;

      var formData = new FormData();
      formData.append('file', file);
      return request.common('uploadImgFile', formData).then(function (_ref2) {
        var data = _ref2.data;

        _this6.form.img_url = data;
        _this6.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
      });
    }
  }
});

/***/ }),

/***/ 3161:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3162);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("105b1946", content, true, {});

/***/ }),

/***/ 3162:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".re-el-form__flex[data-v-27077006]{display:inline}.avatar-uploader .el-upload[data-v-27077006]{border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.avatar-uploader .el-upload[data-v-27077006]:hover{border-color:#409eff}.avatar-uploader-icon[data-v-27077006]{border:1px dashed #d9d9d9;font-size:28px;color:#8c939d;width:178px;height:178px;line-height:178px;text-align:center}.avatar[data-v-27077006]{width:178px;height:178px;display:block;-o-object-fit:cover;object-fit:cover}.upload-tip[data-v-27077006]{margin-top:8px;font-size:12px;color:#999}", "", {"version":3,"sources":["/workspace/src/views/app-popup/pages/AppPopupForm.vue"],"names":[],"mappings":"AACA,mCAAmC,cAAc,CAChD,AACD,6CAA6C,0BAA0B,kBAAkB,eAAe,kBAAkB,eAAe,CACxI,AACD,mDAAmD,oBAAoB,CACtE,AACD,uCAAuC,0BAA0B,eAAe,cAAc,YAAY,aAAa,kBAAkB,iBAAiB,CACzJ,AACD,yBAAyB,YAAY,aAAa,cAAc,oBAAoB,gBAAgB,CACnG,AACD,6BAA6B,eAAe,eAAe,UAAU,CACpE","file":"AppPopupForm.vue","sourcesContent":["\n.re-el-form__flex[data-v-27077006]{display:inline\n}\n.avatar-uploader .el-upload[data-v-27077006]{border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden\n}\n.avatar-uploader .el-upload[data-v-27077006]:hover{border-color:#409EFF\n}\n.avatar-uploader-icon[data-v-27077006]{border:1px dashed #d9d9d9;font-size:28px;color:#8c939d;width:178px;height:178px;line-height:178px;text-align:center\n}\n.avatar[data-v-27077006]{width:178px;height:178px;display:block;-o-object-fit:cover;object-fit:cover\n}\n.upload-tip[data-v-27077006]{margin-top:8px;font-size:12px;color:#999\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/app-popup/table"}},[_vm._v("APP浮窗配置列表")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.formRules,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"标题：","prop":"title"}},[_c('el-input',{attrs:{"disabled":_vm.isDetailMode},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"封面图片：","prop":"img_url"}},[_c('el-upload',{ref:"upload",staticClass:"avatar-uploader",attrs:{"disabled":_vm.isDetailMode,"auto-upload":false,"action":"","show-file-list":false,"on-change":_vm.onChangeFile,"on-remove":_vm.handleRemove}},[(_vm.form.img_url)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.form.img_url}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})]),_vm._v(" "),_c('div',{staticClass:"upload-tip"},[_vm._v("建议尺寸：250px*250px")])],1)],1),_vm._v(" "),_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"小浮窗事件：","prop":"target_type"}},[_c('el-select',{attrs:{"disabled":_vm.isDetailMode,"placeholder":"请选择小浮窗事件"},on:{"change":_vm.onChangeTargetType},model:{value:(_vm.form.target_type),callback:function ($$v) {_vm.$set(_vm.form, "target_type", $$v)},expression:"form.target_type"}},_vm._l((_vm.targetTypes),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1),_vm._v(" "),_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"落地页路径：","prop":"target_url"}},[_c('el-input',{attrs:{"disabled":_vm.isDetailMode || _vm.disableTargetUrl},model:{value:(_vm.form.target_url),callback:function ($$v) {_vm.$set(_vm.form, "target_url", $$v)},expression:"form.target_url"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"上下线时间：","prop":"launch_time_range"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"disabled":_vm.isDetailMode,"value-format":"yyyy-MM-dd HH:mm:ss","type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"center","picker-options":_vm.pickerOptions,"clearable":""},model:{value:(_vm.form.launch_time_range),callback:function ($$v) {_vm.$set(_vm.form, "launch_time_range", $$v)},expression:"form.launch_time_range"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"展示对象：","prop":"user_currentstatus"}},[_c('el-checkbox-group',{model:{value:(_vm.form.user_currentstatus),callback:function ($$v) {_vm.$set(_vm.form, "user_currentstatus", $$v)},expression:"form.user_currentstatus"}},_vm._l((_vm.userOptions.currentstatus),function(item){return _c('el-checkbox',{key:item.value,attrs:{"disabled":_vm.isDetailMode || _vm.disableUserCurrentStatus,"label":item.value}},[_vm._v("\n                "+_vm._s(item.label)+"\n              ")])}),1)],1)],1)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"disabled":_vm.isDetailMode,"type":"primary","native-type":"submit"}},[_vm._v("提交\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/app-popup-form.dfa9e3e3757ef6535512.js